// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"adefc851","643":"578e699b"}[chunkId] + ".chunk.js";
};